import Reveal from "@/components/base/Reveal";
import { guideSteps } from "@/mocks/siteData";

export default function Guide() {
  return (
    <section id="guide" className="bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-5 md:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 text-xs font-medium tracking-widest text-primary-600 uppercase">
              <span className="w-6 h-px bg-primary-400"></span>
              观看指南
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              从选中内容到进入播放，只需四步
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              第一次来的话，照着下面四步走一遍就能理顺整个流程。每一步对应页面上的一个分区，需要的时候可以直接跳过去。
            </p>
          </div>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {guideSteps.map((s, idx) => (
            <Reveal key={s.step} delay={idx * 80}>
              <article className="relative h-full bg-background-50 rounded-lg border border-background-200 p-5 md:p-6">
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-secondary-800 text-accent-400">
                    <i className={`${s.icon} text-2xl`} aria-hidden="true"></i>
                  </span>
                  <span className="font-heading text-3xl font-bold text-background-200">{s.step}</span>
                </div>
                <h3 className="mt-5 font-heading text-lg font-semibold text-foreground-950">{s.title}</h3>
                <p className="mt-2.5 text-sm text-foreground-600 leading-relaxed">{s.text}</p>
                {idx < guideSteps.length - 1 && (
                  <span className="hidden lg:block absolute top-11 -right-3 w-6 text-foreground-300" aria-hidden="true">
                    <i className="ri-arrow-right-s-line text-xl"></i>
                  </span>
                )}
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="md:col-span-2 bg-foreground-950 rounded-lg p-6 md:p-8 flex flex-col md:flex-row md:items-center gap-5">
              <span className="w-14 h-14 flex items-center justify-center rounded-lg bg-accent-500 text-foreground-950 shrink-0">
                <i className="ri-lightbulb-flash-line text-3xl" aria-hidden="true"></i>
              </span>
              <div>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-background-50">小提示：先定方向，再挑内容</h3>
                <p className="mt-2 text-sm text-background-100/70 leading-relaxed">
                  如果你只想随便看看，直接从“影片片单”用题材筛选；如果对画质或设备有明确要求，则先去“播放方式”选好方向，再回到片单，
                  两种方式的效率差别很明显。
                </p>
              </div>
            </div>
            <div className="bg-accent-100 rounded-lg p-6 md:p-8 border border-accent-200">
              <h3 className="font-heading text-base font-semibold text-accent-950">不确定从哪看？</h3>
              <p className="mt-2 text-sm text-accent-900 leading-relaxed">
                《春风食肆》《古城匠人》这类单元结构的内容，任意一集都能进入，适合碎片时间。
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}